import { render, staticRenderFns } from "./StepConfirmacaoInstrucoes.vue?vue&type=template&id=4a6e1a47"
import script from "./StepConfirmacaoInstrucoes.vue?vue&type=script&lang=js"
export * from "./StepConfirmacaoInstrucoes.vue?vue&type=script&lang=js"
import style0 from "./StepConfirmacaoInstrucoes.vue?vue&type=style&index=0&id=4a6e1a47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports